/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>crestron-container.component.ts</name>
///
/// <description>
/// A container that contains the crestron facing UI
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>23 Nov 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 23Nov16 YH  1.0.0000         Task 9542:Revamp Hydrogen Portal left hand side vertical tabs to load only when the user clicks the tab
/// 05Dec16 AA  1.0.0000         Task 764: Changed method for highlighting menu options to make sure correct option is higlighted at all times
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///
import { Component} from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { TranslatedStringsService } from '../../services/language.service';

import { CUIFeatureInterface } from  '../../interfaces/cui-feature.interface';
import { HydUser } from '../../models/user';
import { Subscription } from 'rxjs/Subscription';
import { MediatorService } from '../../services/mediator.service';
import { MediatorEventLookup } from '../../services/mediator-event-lookup.service';
import { LogService } from '../../services/log.service';
import 'rxjs/add/operator/filter';


@Component({
    selector: 'customer-container',
    templateUrl: './crestron-container.component.html'
})
export class CrestronContainerComponent implements CUIFeatureInterface {

    private _listView : string;
    private lblGroups : string;
    private lblAccountsTooltip : string;
    private lblUsersTooltip : string;
    private lblPolicies: string;
    private lblPortalManagementTooltip: string;
    private navigationSubscription: Subscription;

    constructor (
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _hydUser : HydUser,
        private i18n: TranslatedStringsService,
        private log: LogService,
        private mediator: MediatorService
    ) { }

    //----------------------------------------------------------
    //Implementations of Interface
    //----------------------------------------------------------
    ngOnChanges(changes: any) {   };
    ngDoCheck() {   };
    ngAfterContentInit() {   };
    ngAfterContentChecked() {  };
    ngAfterViewInit() {   };
    ngAfterViewChecked() {  };

    ngOnDestroy() {
        this.navigationSubscription.unsubscribe();
    };

    ngOnInit() {
        this._listView = 'accounts';

        //this.i18n.init().then((response) => {

            this.lblGroups = this.i18n.translate('groups-tooltip');
            this.lblAccountsTooltip = this.i18n.translate('accounts-tooltip');
            this.lblUsersTooltip = this.i18n.translate('users-tooltip');
            this.lblPolicies = this.i18n.translate('policies-tooltip'); 
            this.lblPortalManagementTooltip = this.i18n.translate('portal-management');
        //});
        this.highlightActiveMenu();
        this.subscribeToHydrogenLogClickEvent();
    
    };

    private OnGroups() : void {
        this._listView = 'groups';
        this._router.navigate([this.BaseRoute, {outlets: {'list':['groups']}}]);
    }

    private OnAccounts() : void {
        this._listView = 'accounts';
        this._router.navigate([this.BaseRoute, {outlets: {'list':['accounts']}}]);

    }

    private OnUsers() : void {
        this._listView = 'users';
        this._router.navigate([this.BaseRoute, {outlets: {'list':['users']}}]);
    }

    private OnPolicies() : void {
        this._listView = 'policies';
        this._router.navigate([this.BaseRoute, {outlets: {'list':['policies']}}]);
    }

    private OnPortalManagement(): void {
        this._listView = 'portalManagement';
        this._router.navigate([this.BaseRoute, { outlets: { 'list': ['portalManagement'] } }]);
    }

    private get IsCrestronUser() : boolean {
        let ret : boolean = false;
        if (this._hydUser && this._hydUser.Roles)
        {
            let isCrestronUser = this._hydUser.Roles.find(role=>{return role.indexOf("Crestron")!=-1;});
            if (isCrestronUser)
                ret = true;
        }
        return ret;
    }

    private get BaseRoute() : string {
        let baseRoute : string = "/customer";
        if (this.IsCrestronUser)
            baseRoute = "/crestron";
        return baseRoute;
    }

    private highlightActiveMenu() : void {
        // AA 20161212 - We just need to make sure navigation ended before processing path
        this.navigationSubscription = this._router.events.filter(event => event instanceof NavigationEnd).subscribe(() => {
            let root = this._activatedRoute.root;
            // AA 20161212 - Will always be the primary outlet
            let primary = root.children[0];
            let children = primary.children;

            // AA 20161212 - Grab the 'list' outlet and set _listView to current path.
            let list = children.filter(child => child.outlet == 'list')[0];
            if (list && list.snapshot.url.length) {
                this._listView = list.snapshot.url[0].path;
            }
        });
    }

    private subscribeToHydrogenLogClickEvent() {
        this.mediator.Event(MediatorEventLookup.HydrogenLogoClicked).subscribe(
            (payload) => {
                this.OnAccounts();
            },
            err => this.log.logMessage(err),
            () => { }
        );
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/containers/crestron/crestron-container.component.ts